import { Question } from '@/types'

import { getQuestionInfo } from './getQuestionInfo'

export const getAgeDetailValues = (formula: string, questions: Question[]) => {
  const match = formula.match(
    /Q(\d+),only_number=(true|false),include_months=(true|false)/
  )

  if (match) {
    const question = getQuestionInfo(questions, `Q${match[1]}` || '')

    return {
      formIndex: match[1],
      questionDescription: question?.description,
      checkBoxes: [
        {
          param: 'only_number',
          checked: match[2] === 'true',
        },
        {
          param: 'include_months',
          checked: match[3] === 'true',
        },
      ],
    }
  }
}
